import { ValidationMessages } from "@/types/functions";

const validationDE: ValidationMessages = {
    'min_length': '{field} moet ten minste 0:{min} elementen hebben geselecteerd',
    'max_length': '{field} kan maximaal 0:{max} geselecteerde elementen hebben',
    'multiple': 'Het {field} moet een veelvoud zijn van 0:{multiple}.'
}

export default validationDE
